import React, {useState} from 'react'
import Alert from '@mui/material/Alert'
import axios from 'axios'
import { useNavigate } from 'react-router-dom';

function Login() {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState(false);

    const navigate = useNavigate();

    const handleLogin = () => {
        axios.post("http://stream.youradio.co.za:3002/handleLogin",
            {
                username: username,
                password: password
            }
        ).then((response) => {
            if(response.data.message) {
                setStatus(true)
                setMessage(response.data.message);
            }else{
                setStatus(false);
                navigate('/Home')
            }
        })
    }
  return (
    <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%'}}>
        <img src="https://kratos.co.za/img/logofinal.jpg" style={{width: '30%', marginBottom: 40}}/>
        {
            status ? 
            <Alert severity='error' style={{marginBottom: 25}}>{message}</Alert>
            :
            <></>
        }
        
        <div style={{marginBottom: 10, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <input style={{width: '30%', height: 40, padding: 10, fontSize: 24, border: '1px solid grey', borderRadius: 15}} placeholder='Username' onChange={(e) => setUsername(e.target.value)}/>
        </div>
            
        <div style={{marginBottom: 10, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <input style={{width: '30%', height: 40, padding: 10, fontSize: 24, border: '1px solid grey', borderRadius: 15}} placeholder='Password' type="password" onChange={(e) => setPassword(e.target.value)}/>
        </div>

        <div style={{marginBottom: 10, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
            <button style={{marginTop: 20, width: '20%', height: 40, borderRadius: 24, border: '1px solid grey', backgroundColor: 'black', color: 'white', fontSize: 18, cursor: 'pointer'}} onClick={handleLogin}>
                Login
            </button>
        </div>
    </div>
  )
}

export default Login